import { useEffect } from 'react';

import useHistory from 'routing/useHistory';

import workspaceRoutes from './common/Routes';

type WorkspaceInputConfigurationProps = {
  url?: string;
};

// https://stackoverflow.com/questions/52912238/render-methods-should-be-a-pure-function-of-props-and-state
const WorkspaceInputConfiguration = ({
  url = workspaceRoutes.INTEGRATIONS.Workspace.ACTIVITYAPI.index,
}: WorkspaceInputConfigurationProps) => {
  const history = useHistory();

  useEffect(() => {
    history.push(url);
  }, [history, url]);

  return null;
};

export default WorkspaceInputConfiguration;
